import { createContext, ReactNode, useContext } from 'react';
import { UserRole } from './types';

export interface Profile {
  id: string;
  email: string | null;
  upn: string | null;
  displayName: string | null;
  isAdmin: boolean;
  groupCount: number;
  roles: UserRole[];
  /** Open approval requests; zero for anybody who cannot act on them. */
  pendingApprovalCount: number;
}

const ProfileContext = createContext<Profile | null>(null);

/**
 * Who is looking. Pages ask this instead of taking it as a prop, because
 * almost every page needs it and almost none of them needs anything else
 * about the session.
 */
export function useProfile(): Profile {
  const profile = useContext(ProfileContext);
  if (!profile) throw new Error('useProfile outside of ProfileProvider');
  return profile;
}

export function ProfileProvider({ profile, children }: { profile: Profile; children: ReactNode }) {
  return <ProfileContext.Provider value={profile}>{children}</ProfileContext.Provider>;
}
